'use client';

import { DialogBody, ErrorState } from '@pie/amber';
import { GENERIC_BODY, GENERIC_HEADING } from '@/lib/stripe/classifyStripeError';

export const ErrorBody = () => (
  <DialogBody>
    <ErrorState heading={GENERIC_HEADING} helpText={GENERIC_BODY} size="md" />
  </DialogBody>
);
